// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Upcoming Birthdays — page-scoped styles. Companion to BirthdayAlumniCard / BirthdayList / DateRail. */

.bd-page {
    padding-bottom: 3rem;
}

/* ---------- Header ---------- */
.bd-header {
    border-bottom: 1px solid #ececec;
    padding-bottom: 1.25rem;
}

.bd-today-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.85rem;
    border-radius: 999px;
    background: #f4f6fa;
    color: #2c3e50;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
}

.bd-today-badge-label {
    color: #6b7280;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 11px;
}

.bd-today-badge-date {
    font-weight: 600;
    color: #1f2937;
}

/* ---------- Filters ---------- */
.bd-filters {
    margin-top: 1rem;
}

.bd-search-wrapper {
    min-width: 240px;
    max-width: 360px;
}

.bd-search-input {
    padding-right: 2rem;
}

.bd-search-clear {
    position: absolute;
    right: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    color: #6b7280;
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer;
    padding: 0 0.25rem;
}

.bd-select {
    width: auto;
    min-width: 160px;
}

.bd-clear-all {
    color: #4f46e5;
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    margin-left: auto;
}

.bd-clear-all:hover {
    text-decoration: underline;
}

.bd-chips {
    margin-top: 0.25rem;
}

.bd-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.6rem;
    border-radius: 999px;
    background: #eef2ff;
    color: #3730a3;
    font-size: 12px;
    font-weight: 500;
}

.bd-chip-x {
    background: transparent;
    border: none;
    color: #6366f1;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    padding: 0;
}

/* ---------- Tabs ---------- */
.bd-tabs {
    border-top: 1px solid #ececec;
    padding-top: 1rem;
}

.bd-tab {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.95rem;
    border-radius: 999px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
}

.bd-tab:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
}

.bd-tab--active,
.bd-tab--active:hover {
    background: #111827;
    border-color: #111827;
    color: #ffffff;
}

.bd-tab-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    padding: 0 0.4rem;
    height: 1.25rem;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.08);
    font-size: 11px;
    font-weight: 600;
}

.bd-tab--active .bd-tab-count {
    background: rgba(255, 255, 255, 0.18);
}

/* ---------- Section heading & groups ---------- */
.bd-section-heading {
    color: #1f2937;
}

.bd-group {
    display: flex;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
    align-items: flex-start;
}

.bd-group-grid {
    flex: 1 1;
    margin: 0;
}

.bd-rail {
    flex: 0 0 96px;
    padding: 0.75rem 0.5rem;
    border-radius: 8px;
    background: #f3f4f6;
    text-align: center;
}

.bd-rail-date {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    line-height: 1.1;
}

.bd-rail-rel {
    margin-top: 0.25rem;
    font-size: 12px;
    color: #6b7280;
    text-transform: lowercase;
}

.bd-rail--today {
    background: #4f46e5;
    position: relative;
}

.bd-group:not(:last-child) {
    border-bottom: 1px solid #e5e2e2;
    padding-bottom: 30px;
    margin-bottom: 15px;
}

.bd-rail--today .bd-rail-date,
.bd-rail--today .bd-rail-rel {
    color: #ffffff;
}

.bd-rail--today:before {
    content: '🎉';
    font-size: 18px;
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fff;
    padding: 3px;
    border-radius: 50%;
    border: 2px solid #4f46e5;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ---------- Card ---------- */
.bd-card {
    display: flex;
    gap: 0.75rem;
    padding: 0.85rem;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #ececec;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
    height: 100%;
    cursor: pointer;
}

.bd-card:hover {
    border-color: #c7d2fe;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.08);
    transform: translateY(-1px);
}

.bd-card-photo {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #eef2ff;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4f46e5;
    font-weight: 600;
    font-size: 16px;
}

.bd-card-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.bd-card-body {
    min-width: 0;
}

.bd-card-name {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 0.15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bd-card-role,
.bd-card-batch,
.bd-card-city {
    font-size: 13px;
    color: #4b5563;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bd-card-role {
    margin-bottom: 0.1rem;
}

.bd-card-batch {
    color: #6b7280;
    margin-bottom: 0.1rem;
}

.bd-card-city {
    color: #6b7280;
}

/* ---------- Skeletons ---------- */
@keyframes bdSkeletonPulse {
    0% { opacity: 0.55; }
    50% { opacity: 0.85; }
    100% { opacity: 0.55; }
}

.bd-skeleton {
    margin-top: 1rem;
}

.bd-skeleton-row {
    display: flex;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
}

.bd-skeleton-rail {
    flex: 0 0 96px;
    height: 64px;
    border-radius: 8px;
    background: #eef2f7;
    animation: bdSkeletonPulse 1.4s ease-in-out infinite;
}

.bd-skeleton-grid {
    flex: 1 1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
}

.bd-skeleton-card {
    height: 86px;
    border-radius: 10px;
    background: #eef2f7;
    animation: bdSkeletonPulse 1.4s ease-in-out infinite;
}

/* ---------- Append spinner & errors ---------- */
.bd-append-spinner {
    color: #4b5563;
}

/* ---------- Responsive: stack the date rail above the grid on mobile ---------- */
@media (max-width: 767.98px) {
    .bd-group {
        flex-direction: column;
        gap: 0.75rem;
    }
    .bd-rail {
        flex: 0 0 auto;
        position: static;
        width: max-content;
        padding: 0.4rem 0.75rem;
        text-align: left;
        display: inline-flex;
        align-items: baseline;
        gap: 0.5rem;
    }
    .bd-rail-date {
        font-size: 15px;
    }
    .bd-skeleton-row {
        flex-direction: column;
    }
    .bd-skeleton-grid {
        grid-template-columns: 1fr;
    }
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .bd-skeleton-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/management/birthdays/birthdays.css"],"names":[],"mappings":"AAAA,wGAAwG;;AAExG;IACI,oBAAoB;AACxB;;AAEA,iCAAiC;AACjC;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,+BAA+B;AAC/B;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,mDAAmD;AACnD;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,SAAS;AACb;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gFAAgF;IAChF,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;;IAGI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,KAAK,aAAa,EAAE;IACpB,MAAM,aAAa,EAAE;IACrB,OAAO,aAAa,EAAE;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA,kDAAkD;AAClD;IACI,cAAc;AAClB;;AAEA,mFAAmF;AACnF;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;QAChB,oBAAoB;QACpB,qBAAqB;QACrB,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ","sourcesContent":["/* Upcoming Birthdays — page-scoped styles. Companion to BirthdayAlumniCard / BirthdayList / DateRail. */\n\n.bd-page {\n    padding-bottom: 3rem;\n}\n\n/* ---------- Header ---------- */\n.bd-header {\n    border-bottom: 1px solid #ececec;\n    padding-bottom: 1.25rem;\n}\n\n.bd-today-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.4rem 0.85rem;\n    border-radius: 999px;\n    background: #f4f6fa;\n    color: #2c3e50;\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.bd-today-badge-label {\n    color: #6b7280;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-size: 11px;\n}\n\n.bd-today-badge-date {\n    font-weight: 600;\n    color: #1f2937;\n}\n\n/* ---------- Filters ---------- */\n.bd-filters {\n    margin-top: 1rem;\n}\n\n.bd-search-wrapper {\n    min-width: 240px;\n    max-width: 360px;\n}\n\n.bd-search-input {\n    padding-right: 2rem;\n}\n\n.bd-search-clear {\n    position: absolute;\n    right: 0.6rem;\n    top: 50%;\n    transform: translateY(-50%);\n    border: none;\n    background: transparent;\n    color: #6b7280;\n    font-size: 1.1rem;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 0.25rem;\n}\n\n.bd-select {\n    width: auto;\n    min-width: 160px;\n}\n\n.bd-clear-all {\n    color: #4f46e5;\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 500;\n    margin-left: auto;\n}\n\n.bd-clear-all:hover {\n    text-decoration: underline;\n}\n\n.bd-chips {\n    margin-top: 0.25rem;\n}\n\n.bd-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.25rem 0.6rem;\n    border-radius: 999px;\n    background: #eef2ff;\n    color: #3730a3;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.bd-chip-x {\n    background: transparent;\n    border: none;\n    color: #6366f1;\n    font-size: 1rem;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ---------- Tabs ---------- */\n.bd-tabs {\n    border-top: 1px solid #ececec;\n    padding-top: 1rem;\n}\n\n.bd-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0.95rem;\n    border-radius: 999px;\n    border: 1px solid #e5e7eb;\n    background: #f9fafb;\n    color: #374151;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.bd-tab:hover {\n    background: #f3f4f6;\n    border-color: #d1d5db;\n}\n\n.bd-tab--active,\n.bd-tab--active:hover {\n    background: #111827;\n    border-color: #111827;\n    color: #ffffff;\n}\n\n.bd-tab-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.5rem;\n    padding: 0 0.4rem;\n    height: 1.25rem;\n    border-radius: 999px;\n    background: rgba(0, 0, 0, 0.08);\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.bd-tab--active .bd-tab-count {\n    background: rgba(255, 255, 255, 0.18);\n}\n\n/* ---------- Section heading & groups ---------- */\n.bd-section-heading {\n    color: #1f2937;\n}\n\n.bd-group {\n    display: flex;\n    gap: 1.25rem;\n    margin-bottom: 1.5rem;\n    align-items: flex-start;\n}\n\n.bd-group-grid {\n    flex: 1;\n    margin: 0;\n}\n\n.bd-rail {\n    flex: 0 0 96px;\n    padding: 0.75rem 0.5rem;\n    border-radius: 8px;\n    background: #f3f4f6;\n    text-align: center;\n}\n\n.bd-rail-date {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.1;\n}\n\n.bd-rail-rel {\n    margin-top: 0.25rem;\n    font-size: 12px;\n    color: #6b7280;\n    text-transform: lowercase;\n}\n\n.bd-rail--today {\n    background: #4f46e5;\n    position: relative;\n}\n\n.bd-group:not(:last-child) {\n    border-bottom: 1px solid #e5e2e2;\n    padding-bottom: 30px;\n    margin-bottom: 15px;\n}\n\n.bd-rail--today .bd-rail-date,\n.bd-rail--today .bd-rail-rel {\n    color: #ffffff;\n}\n\n.bd-rail--today:before {\n    content: '🎉';\n    font-size: 18px;\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    background: #fff;\n    padding: 3px;\n    border-radius: 50%;\n    border: 2px solid #4f46e5;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* ---------- Card ---------- */\n.bd-card {\n    display: flex;\n    gap: 0.75rem;\n    padding: 0.85rem;\n    border-radius: 10px;\n    background: #ffffff;\n    border: 1px solid #ececec;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n    height: 100%;\n    cursor: pointer;\n}\n\n.bd-card:hover {\n    border-color: #c7d2fe;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.08);\n    transform: translateY(-1px);\n}\n\n.bd-card-photo {\n    flex: 0 0 48px;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #eef2ff;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #4f46e5;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.bd-card-photo img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.bd-card-body {\n    min-width: 0;\n}\n\n.bd-card-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #111827;\n    margin-bottom: 0.15rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.bd-card-role,\n.bd-card-batch,\n.bd-card-city {\n    font-size: 13px;\n    color: #4b5563;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.bd-card-role {\n    margin-bottom: 0.1rem;\n}\n\n.bd-card-batch {\n    color: #6b7280;\n    margin-bottom: 0.1rem;\n}\n\n.bd-card-city {\n    color: #6b7280;\n}\n\n/* ---------- Skeletons ---------- */\n@keyframes bdSkeletonPulse {\n    0% { opacity: 0.55; }\n    50% { opacity: 0.85; }\n    100% { opacity: 0.55; }\n}\n\n.bd-skeleton {\n    margin-top: 1rem;\n}\n\n.bd-skeleton-row {\n    display: flex;\n    gap: 1.25rem;\n    margin-bottom: 1.5rem;\n}\n\n.bd-skeleton-rail {\n    flex: 0 0 96px;\n    height: 64px;\n    border-radius: 8px;\n    background: #eef2f7;\n    animation: bdSkeletonPulse 1.4s ease-in-out infinite;\n}\n\n.bd-skeleton-grid {\n    flex: 1;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0.75rem;\n}\n\n.bd-skeleton-card {\n    height: 86px;\n    border-radius: 10px;\n    background: #eef2f7;\n    animation: bdSkeletonPulse 1.4s ease-in-out infinite;\n}\n\n/* ---------- Append spinner & errors ---------- */\n.bd-append-spinner {\n    color: #4b5563;\n}\n\n/* ---------- Responsive: stack the date rail above the grid on mobile ---------- */\n@media (max-width: 767.98px) {\n    .bd-group {\n        flex-direction: column;\n        gap: 0.75rem;\n    }\n    .bd-rail {\n        flex: 0 0 auto;\n        position: static;\n        width: max-content;\n        padding: 0.4rem 0.75rem;\n        text-align: left;\n        display: inline-flex;\n        align-items: baseline;\n        gap: 0.5rem;\n    }\n    .bd-rail-date {\n        font-size: 15px;\n    }\n    .bd-skeleton-row {\n        flex-direction: column;\n    }\n    .bd-skeleton-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n    .bd-skeleton-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
